const asyncSelectCustomStyles = {
    control: (base, state) => ({
        ...base,
        border: '1px solid #ced4da !important',
        borderRadius: '0px',
        minHeight: '42px',
        boxShadow: state.isFocused ? '0 0 0 0.2rem #71964a44' : 'none',
        '&:hover': {
            borderColor: '#71964a !important'
        },
        fontFamily: "Archivo Expanded, sans-serif !important"
    }),

    valueContainer: (base) => ({
        ...base,
        padding: '2px 8px'
    }),

    placeholder: (base) => ({
        ...base,
        color: '#6c757d'
    }),

    multiValue: (base) => ({
        ...base,
        backgroundColor: '#deedcf',
        borderRadius: '3px'
    }),

    multiValueLabel: (base) => ({
        ...base,
        color: '#495057',
        fontSize: '100%'
    }),

    multiValueRemove: (base) => ({
        ...base,
        alignItems: 'center',
        borderRadius: '50%',
        borderStyle: 'solid',
        borderWidth: '1.9px',
        display: 'flex',
        margin: '0 4px',
        width: '18px',
        height: '18px',
        marginTop: '5px',
        paddingRight: '0px',
        paddingLeft: '1px'
    }),

    indicatorSeparator: (base) => ({
        ...base,
        display: 'none',
    }),

    clearIndicator: (base) => ({
        ...base,
        color: '#ced4da',
        cursor: 'pointer',
        padding: '8px',
        color: "#555",
        "&:hover": { color: "#555" },
    }),
    dropdownIndicator: (base, state) => ({
        ...base,
        color: state.isFocused ? "#555" : "#555",
        "&:hover": {
            color: "#555",
        },
        svg: {
            width: 18,
            height: 18,
        },
    }),

    option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? '#deedcf' : 'white',
        color: '#495057',
        cursor: 'pointer'
    })
};

export { asyncSelectCustomStyles };